import type { IHeader, IMenuItem } from '@/interfaces';
import type React from 'react';
import DropdownMenuItem from './DropdownMenuItem';
import { DropdownNavigationWrapper, type NavPlacement } from './DropdownNavigation.styles';
import SingleMenuItem from './SingleMenuItem';

const DropdownNavigation: React.FC<IHeader & { placement?: NavPlacement }> = ({ itemList, placement = 'left' }) => {
  if (!itemList?.length) return null;

  return (
    <DropdownNavigationWrapper placement={placement}>
      {itemList.map((navItem: IMenuItem, index: number) => {
        if (!navItem?.innerData?.length) {
          return <SingleMenuItem key={index} data={navItem} />;
        }

        return <DropdownMenuItem key={index} data={navItem} />;
      })}
    </DropdownNavigationWrapper>
  );
};

export default DropdownNavigation;
